import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useMemo } from 'react';
import { AdaptiveFieldSelect } from '@sbercloud/uikit-product-mobile-fields';
import { useCalculatorContext } from '../../../contexts';
import { parseKeyToDataTest } from '../../../utils';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function convertItemsToOptions(items) {
  return items.map(function (item) {
    var _item$label;
    return {
      value: item.value,
      disabled: item.disabled,
      option: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item.value,
      beforeContent: item.icon
    };
  });
}
export function SelectSingleUi(_ref) {
  var _ref2, _relatedUiProps$visib;
  var decoratorProps = _ref.decoratorProps,
    uiProps = _ref.uiProps,
    value = _ref.value,
    onChange = _ref.onChange,
    itemsProp = _ref.items,
    watchedValues = _ref.watchedValues,
    relateFn = _ref.relateFn,
    accessorKey = _ref.accessorKey;
  var _useCalculatorContext = useCalculatorContext(),
    layoutType = _useCalculatorContext.layoutType;
  var _useMemo = useMemo(function () {
      var _relateFn;
      return (_relateFn = relateFn === null || relateFn === void 0 ? void 0 : relateFn(watchedValues !== null && watchedValues !== void 0 ? watchedValues : {})) !== null && _relateFn !== void 0 ? _relateFn : {};
    }, [relateFn, watchedValues]),
    relatedItems = _useMemo.items,
    relatedDecoratorProps = _useMemo.decoratorProps,
    relatedUiProps = _useMemo.uiProps;
  var items = useMemo(function () {
    return relatedItems !== null && relatedItems !== void 0 ? relatedItems : itemsProp;
  }, [itemsProp, relatedItems]);
  var dataTestAttribute = parseKeyToDataTest('select', accessorKey);
  useEffect(function () {
    if (!items.find(function (item) {
      return String(item.value) === String(value);
    })) {
      var _items$;
      onChange === null || onChange === void 0 ? void 0 : onChange(String(items === null || items === void 0 ? void 0 : (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.value));
    }
  }, [value, onChange, items, relatedItems]);
  var visible = (_ref2 = (_relatedUiProps$visib = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.visible) !== null && _relatedUiProps$visib !== void 0 ? _relatedUiProps$visib : uiProps === null || uiProps === void 0 ? void 0 : uiProps.visible) !== null && _ref2 !== void 0 ? _ref2 : true;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [!decoratorProps.label && /*#__PURE__*/_jsx("div", {
      className: styles.zeroLabel
    }), /*#__PURE__*/_jsx(AdaptiveFieldSelect, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      searchable: false,
      showClearButton: false,
      layoutType: layoutType,
      widthStrategy: "eq"
    }, decoratorProps), relatedDecoratorProps), {}, {
      size: "m",
      selection: "single",
      value: value,
      onChange: onChange,
      options: convertItemsToOptions(items),
      "data-test-id": dataTestAttribute
    }, uiProps), relatedUiProps))]
  });
}
export function SelectMultipleUi(_ref3) {
  var _ref4, _relatedUiProps$visib2;
  var decoratorProps = _ref3.decoratorProps,
    uiProps = _ref3.uiProps,
    value = _ref3.value,
    onChange = _ref3.onChange,
    itemsProp = _ref3.items,
    relateFn = _ref3.relateFn,
    watchedValues = _ref3.watchedValues;
  var _useCalculatorContext2 = useCalculatorContext(),
    layoutType = _useCalculatorContext2.layoutType;
  var _useMemo2 = useMemo(function () {
      var _relateFn2;
      return (_relateFn2 = relateFn === null || relateFn === void 0 ? void 0 : relateFn(watchedValues !== null && watchedValues !== void 0 ? watchedValues : {})) !== null && _relateFn2 !== void 0 ? _relateFn2 : {};
    }, [relateFn, watchedValues]),
    relatedItems = _useMemo2.items,
    relatedDecoratorProps = _useMemo2.decoratorProps,
    relatedUiProps = _useMemo2.uiProps;
  var items = useMemo(function () {
    return relatedItems !== null && relatedItems !== void 0 ? relatedItems : itemsProp;
  }, [itemsProp, relatedItems]);
  var visible = (_ref4 = (_relatedUiProps$visib2 = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.visible) !== null && _relatedUiProps$visib2 !== void 0 ? _relatedUiProps$visib2 : uiProps === null || uiProps === void 0 ? void 0 : uiProps.visible) !== null && _ref4 !== void 0 ? _ref4 : true;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [!decoratorProps.label && /*#__PURE__*/_jsx("div", {
      className: styles.zeroLabel
    }), /*#__PURE__*/_jsx(AdaptiveFieldSelect, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      layoutType: layoutType,
      searchable: false,
      showClearButton: false
    }, decoratorProps), relatedDecoratorProps), {}, {
      selection: "multiple",
      size: "m",
      value: value,
      onChange: onChange,
      options: convertItemsToOptions(items)
    }, uiProps), relatedUiProps))]
  });
}